import React, { useState, useEffect } from "react";
import Map from "../map";
import '../orders/ordersmap.css';
import { useFetch } from "../../api/FetchApiData";
import Select from "react-select";
//import WsPositionSharing from "../../api/WsPositionSharing";

export default function TrackingMap({close, destination_=null})
{
    const [orders,setOrders] = useState([]);
    const [selectOptions,setSelOptions] = useState([]);
    const fetchData = useFetch();
    const [map_center,setMapCenter] = useState({latitude:-11.470978, longitude:43.387745});

    const onMapMoveEnd = (bounds)=>{
        fetchData.PostData({bounds:bounds},'sales/filter/1/').then((result)=>{
            if(result.result)
            {
                let arr = [];
                let ids = [];
                result.sales.forEach(element => {
                    let address = {...element.address,orders:[]};
                    address.type = 'delivery_point';
                    console.log(element);
                    if(!ids.includes(address.id))
                    {
                        address = {...address,orders:[element.order_number]}
                        arr.push(address);
                        ids.push(address.id);
                    }
                    else
                    {   
                        const ind = arr.findIndex((el)=>el.id===address.id); 
                        arr[ind].orders.push(element.order_number);
                    }

                });
                setOrders([...new Set([...orders, ...arr])])
            }
        })
    }

    const onPostitionReceived = (data)=>{
        console.log(data);
        setOrders([data]);
    }

    useEffect(()=>{
        //WsPositionSharing.onMessage(onPostitionReceived);
        return ()=>{}
    },[])
    

    useEffect(()=>{
        if(orders.length>0)
        {
            console.log("set center");
            const center = {latitude:orders[0].coords.latitude,longitude:orders[0].coords.latitude};
            setMapCenter(center);
        }
    },[orders]);
    
    return(
        <div id="MapContent" style={{height:'90vh',marginTop:'10px',width:'100%'}}>
            <Map onMoveEnd={onMapMoveEnd} zoom={15} locations={orders} newLocation={null} map_center={map_center} />
            {
                <div className='partners-map-controls'>
                    <div style={{width:'60%',marginRight:'5px'}}>
                        <Select options={selectOptions}  />
                    </div>
                    <input onClick={e=>{}} className='partners-map-itn' type='button'  value={'Itinéraire'} />
                </div>
            }
            <a className="globalclosemap" onClick={e=>{close()}}>
                &times;
            </a>
        </div>);
}